import React from 'react';
import styles from '../../styles.module.css';
import MainIcons from '@/icons/main';
import PlateInput from '@/components/pages/home/HomeContent/HomeHero/PlateLookup/PlateInput';
import Button from '@/components/common/Button';
import { payType, ServiceSubCategory } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';

export default function PlatesSection({
  data,
  onClick,
  callBackHistory,
}: {
  data?: ServiceSubCategory;
  onClick?: (x?: payType, item?: any, callBackHistory?: any) => void;
  callBackHistory?: any;
}) {
  const { isLogin } = useLayoutContext();
  const items = [
    {
      icon: <MainIcons.shieldIcon fill="var(--green-bright)" width={'14px'} height={'14px'} />,
      text: 'مرجع رسمی راهور',
    },
    {
      icon: <MainIcons.LockIcon fill="var(--green-bright)" width={'14px'} height={'14px'} />,
      text: 'پرداخت امن',
    },
    {
      icon: <MainIcons.clockIcon fill="var(--green-bright)" width={'14px'} height={'14px'} />,
      text: 'نتیجه در ۱ ثانیه',
    },
  ];
  console.log('dd==', data);
  return (
    <div className={`panel ${styles.plateContainer}`}>
      {data && data?.show_plate && isLogin && (
        <>
          <div className={`${styles.notif}`}>
            <MainIcons.notifIcon fill="var(--accent-light)" width={'14px'} height={'14px'} />
            <span>شماره پلاک خودرو</span>
          </div>

          {/* <PlateBadge car={activeCar} type="large" size="lg" className={`${styles.mobilePlate}`} /> */}
          <PlateInput disabled={true} inputClass={`${styles.inputContainer}`} />
        </>
      )}
      <Button
        className={`btn btn-primary ${styles.button} squareButton`}
        wrapperStyle={`w-full`}
        onClick={() => {
          onClick && onClick('inq', data, callBackHistory);
        }}
      >
        <MainIcons.flashIcon fill="var(--paper)" />
        استعلام
      </Button>
      <div className={`${styles.items}`}>
        {items?.map((x, j) => (
          <div key={j}>
            {x?.icon}
            <span>{x?.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
